module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.css
// module id = ./src/app/components/admin/admin.component.css
// module chunks = main